import {ColorModeScript} from '@chakra-ui/react'
import {theme} from 'lib/styles/theme'
import React from 'react'
import ReactDOM from 'react-dom/client'
import {PostHogProvider} from 'posthog-js/react'
import App from './App'

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY
const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-11-30',
} as const

const AppWithProviders = () => (
  <>
    <ColorModeScript initialColorMode={theme.config?.initialColorMode} />
    <App />
  </>
)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  posthogKey ? (
    <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
      <AppWithProviders />
    </PostHogProvider>
  ) : (
    <AppWithProviders />
  ),
)
